export default (meta, store) => {

    if (!meta?.houseKey) {
        console.log('[ROE] No houseKey');
        return;
    }

    const openModal = () => {
        // Reset state
        store.commit('SET_METADATA', {
            isRightOfEntry: false,
            roeRedirect: false,
            houseKey: null,
            statusCode: null,
            line1: null,
            line2: null,
            stateOrProvince: null,
            postalCode: null,
            city: null,
            town: null,
            dwellingType: null
        });

        // Open modal
        store.dispatch('toggleCheckAvailabilityModal', {
            visible: true
        });
    }

    const gaFormImpression = () => {
        console.log('[ROE] Form Impression')
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'event_tracking',
            'event_name': 'roe_form',
            'event_action': 'impression',
            'event_label': 'go_fiber'
        })
    }

    const gaFormSubmission = () => {
        console.log('[ROE] Form Submission')
        // If any form inputs with these names exist and are non-empty, set event_label_2 to true, otherwise false:
        // propertyOwnerName, propertyOwnerStreetAddress, propertyOwnerEmail, ownerPhoneNumber

        const formInputs = [
            'propertyOwnerName',
            'propertyOwnerStreetAddress',
            'propertyOwnerEmail',
            'ownerPhoneNumber'
        ]

        const anyHoaInputFilled = formInputs.some(inputName => {
            const input = document.querySelector(`input[name="${inputName}"]`);
            return input && input.value.trim() !== '';
        });

        window.dataLayer = window.dataLayer || [];
        const eventData = {
            'event': 'event_tracking',
            'event_name': 'roe_form',
            'event_action': 'submission',
            'event_label': 'go_fiber',
            'event_label_2': anyHoaInputFilled
        };

        console.table(eventData)
        // This is getting cancelled because of the page redirect after form submission.
        window.dataLayer.push(eventData)
    }

    const handleForm = (form) => {
        // Add address above form
        const goFiberAddress = document.querySelector('.gofiber-address');
        const roeAddress = `${meta?.line1 ? meta.line1 + ',' : '' || ''}
                            ${meta?.line2 ? meta.line2 + ',' : ''}
                            ${meta?.stateOrProvince || ''}
                            ${meta?.postalCode || ''}`.trim();

        if (!goFiberAddress) {
            const addressDiv = document.createElement('div');
            addressDiv.innerHTML = `
                <div class="gofiber-address max-w-lg max-h-lg m-auto">
                    <p class="xsMobile:pl-2 smMobile:pl-2">
                        <span class="font-bold">Your Address:</span>
                        <span class="roe-address capitalize">${roeAddress}</span>
                        <a data-qa="roeChangeLink" class="underline change-address-link" href="#">Change?</a>
                    </p>
                </div>
            `;

            // Add the event listener after creating the element
            const changeLink = addressDiv.querySelector('.change-address-link');
            if (changeLink) {
                changeLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    openModal();
                });
            }

            form.insertAdjacentElement('afterbegin', addressDiv);
        } else {
            document.querySelector('.gofiber-address .roe-address').textContent = roeAddress;
        }

        //Scroll to form
        form.scrollIntoView({behavior: 'smooth'})

        //Select form fields
        const houseKeyField = document.querySelector('input[name="houseKey"]')
        const statusCodeField = document.querySelector('input[name="statusCode"]')
        const line1Field = document.querySelector('input[name="streetAddress"]')
        const line2Field = document.querySelector('input[name="aptUnit"]')
        const zipField = document.querySelector('input[name="zip"]')
        const dwellingType = document.querySelector('input[name="dwellingType"]')

        //Set form field values
        if (houseKeyField) houseKeyField.value = meta?.houseKey || ""
        if (statusCodeField) statusCodeField.value = meta?.statusCode || ""
        if (line1Field) line1Field.value = meta?.line1 || ""
        if (line2Field) line2Field.value = meta?.line2 || ""
        if (zipField) zipField.value = meta?.postalCode || ""
        if(dwellingType) dwellingType.value = meta?.dwellingType || ""

        // Add data-qa attribute to right of entry form submit button
        let roeFormSubmit = document.querySelector('button[data-name="form_submit"]');
        roeFormSubmit && roeFormSubmit.setAttribute('data-qa', 'roeSubmitBtn');

        // Dismiss modal
        store.dispatch('toggleCheckAvailabilityModal', {
            visible: false
        });

        // On form submit, call gaFormSubmission()
        form.addEventListener('submit', (e) => {
            console.log('Form Submit e.target.id', e.target.id);
            e.preventDefault()
            gaFormSubmission()
            setTimeout(() => {
                e.target.submit()
            }, 300)
        })
    }

    const showForm = () => {
        const fiberFormDiv = document.getElementById('fiber-form');

        if (fiberFormDiv) {
            // Make sure the form itself is visible
            fiberFormDiv.style.visibility = 'visible';
            fiberFormDiv.style.height = 'auto';

            // Find parent with 'relative' class
            const parentContainer = fiberFormDiv.closest('.relative.bg-gray-100');
            if (parentContainer) {
                parentContainer.style.visibility = 'visible';
                parentContainer.style.height = 'auto';
            }
            // Measure form impression
            gaFormImpression()
        }
    }

    // Hide cta if already addressed in to right of entry location
    const modalBtn = document.querySelector('#hero-banner button');
    modalBtn.style.display = "none";

    // First try immediate check
    if (!meta?.roeRedirect) {
        let fiberForm = document.getElementById('fiber-form')
        if (fiberForm) {
            showForm()
            handleForm(fiberForm)
        }
    } 

    if (meta?.roeRedirect) {
        // If we're redirecting, wait for DOMContentLoaded
        document.addEventListener('DOMContentLoaded', () => {
            let fiberForm = document.getElementById('fiber-form')
            if (fiberForm) {
                showForm()
                handleForm(fiberForm)
            }
        })
    }  
}
